import * as angular from "angular";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";

let UserAutocompleteComponent = {
    templateUrl: "/angular/components/user/user-autocomplete.component.html",
    selector: "userAutocomplete",
    bindings: {
        selectedUsers: "=?",
        selectedUser: "=?",
        userId: "=?",
        invites: "=?",
        label: "=?",
        placeholder: "@?",
        noLabel: "=?",
        autoFocus: "=?",
        clearButton: "=?",
        allowUnassigned: "=?",
        required: "=?",
        isDisabled: "=?",
        showEmail: "=?",
        permissions: "=?",
    },

    controller: class UserAutocompleteController {
        // * bindings for typescript compiler *
        public selectedUsers?: any;
        public selectedUser?: any;
        public allowUnassigned?: boolean;
        public userId?: number | string;
        public invites?: any;
        public label?: any;
        public placeholder?: string;
        public noLabel?: any;
        public autoFocus?: any;
        public clearButton?: any;
        public required?: any;
        public isDisabled?: any;
        public showEmail?: any;
        public permissions?: any;
        // ************************************

        private $scope: any;
        private dataProvider: UserDataProvider;
        private $http: any;
        private $q: any;
        private __env: any;
        private modelsUtils: any;

        public false: any;
        public search: any;
        public searchPromise: any;
        public previousSearch: any;
        // The array handed to md-autocomplete. It is updated in place so a
        // refresh that lands while the dropdown is open refills it.
        private shownUsers: any[] = [];
        public text: any;
        public email_regex: any;
        public sendQuery: any;
        public matchedUsers: any;
        public found: any;

        constructor(
            $scope: any,
            UserDataProvider: UserDataProvider,
            $http: any,
            $q: any,
            __env: any,
            ModelsUtils: any
        ) {
            this.$scope = $scope;
            this.dataProvider = UserDataProvider;
            this.$http = $http;
            this.$q = $q;
            this.__env = __env;
            this.modelsUtils = ModelsUtils;
        }

        $onInit() {
            this.label = this.label ? this.label : "User";
            this.noLabel = this.noLabel;
            this.autoFocus = this.autoFocus ? this.autoFocus : false;
            this.clearButton = this.clearButton ? this.clearButton : false;
            this.showEmail = this.showEmail ? this.showEmail : false;
            this.required = this.required ? this.required : false;
            this.isDisabled = this.isDisabled ? this.isDisabled : false;
            this.selectedUsers = this.selectedUsers ? this.selectedUsers : null;
            this.selectedUser = this.selectedUser ? this.selectedUser : null;

            if (this.selectedUser && this.selectedUser.uid) {
                this.search = this.itemText(this.selectedUser);
            }

            if (this.selectedUsers) {
                this.$scope.$watch(
                    () => this.selectedUsers,
                    (newValue, oldValue) => {
                        if (oldValue && newValue !== oldValue) {
                            this.searchUsers(this.search, true);
                        }
                    },
                    true
                );
            }
        }

        itemText(user: User): string {
            if (user.uid) {
                let text: string = user.ufname + " " + user.ulname;

                if (this.showEmail) {
                    text = text + " - " + user.uemail;
                }

                return text;
            } else {
                return "Unassigned";
            }
        }

        selected(user: User): void {
            if (user) {
                this.selectedUser = user;
                this.userId = user.uid;
                if (this.selectedUsers) {
                    this.selectedUsers.push({
                        uid: user.uid ?? null,
                        uemail: user.uemail ?? null,
                        ucountrycode: user.ucountrycode ?? null,
                        uphonenumber: user.uphonenumber ?? null,
                        ufname: user.ufname ?? null,
                        ulname: user.ulname ?? null,
                        color: user.color ?? null,
                        images: {
                            small: user.images?.small ?? null,
                            medium: user.images?.medium ?? null,
                        },
                        // Preserve pending-invite fields so invites picked from
                        // the list keep their identity (and actually save).
                        campaigninviteid: user.campaigninviteid ?? null,
                        campaigninviteemail: user.campaigninviteemail ?? null,
                        campaigninvitephonenumber:
                            user.campaigninvitephonenumber ?? null,
                        campaigninvitecountrycode:
                            user.campaigninvitecountrycode ?? null,
                    });
                    this.search = "";
                }
            }
        }

        searchUsers(query: any, refresh: boolean): Promise<any> {
            if (query === this.previousSearch && !refresh) {
                // Answer at once from the current page (a user just picked is
                // filtered out); a refresh in flight refills the list later.
                return this.$q.resolve(
                    this.showUsers(this.filterMatchedUsers(this.matchedUsers))
                );
            } else {
                this.selectedUser = {};
            }
            this.previousSearch = query;
            const deferred = this.$q.defer();
            if (this.searchPromise)
                this.searchPromise.resolve("user cancelled");
            this.searchPromise = this.$q.defer();

            let email_regex =
                /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
            let sendQuery = query.replace(email_regex, "");
            sendQuery = sendQuery.replace("-", "");

            this.$http
                .post(
                    this.__env.apiUrl() + "/campaign/user/alldash",
                    {
                        filters: {
                            search: sendQuery,
                            needsEmail: this.showEmail,
                            limit: this.dataProvider.loadSize,
                            permission: this.permissions,
                            // Skip users already picked server-side, so the
                            // limited page is filled with users still pickable.
                            excludeUids: this.selectedUids(),
                        },
                    },
                    {
                        timeout: this.searchPromise.promise,
                    }
                )
                .then((response: object) => {
                    if (!response || !response["data"] || !response["data"])
                        deferred.reject();
                    this.matchedUsers = this.filterMatchedUsers(
                        response["data"].data
                    );

                    if (this.allowUnassigned) {
                        if (
                            !query ||
                            query == "" ||
                            "unassigned".includes(query.toLowerCase())
                        ) {
                            this.matchedUsers.unshift({
                                uid: null,
                                name: "Unassigned",
                            });
                        }
                    }

                    deferred.resolve(this.showUsers(this.matchedUsers));
                });
            return deferred.promise;
        }

        private showUsers(users: any[]): any[] {
            this.shownUsers.splice(0, this.shownUsers.length, ...users);
            return this.shownUsers;
        }

        selectedUids(): number[] {
            const uids: number[] = [];
            angular.forEach(this.selectedUsers, (selectedUser: any) => {
                const uid = Number(selectedUser.uid);
                if (selectedUser.uid && uid > 0) {
                    uids.push(uid);
                }
            });
            return uids;
        }

        filterMatchedUsers(data: any): User[] {
            let matchedUsers = [];
            angular.forEach(data, (user: any) => {
                let found = false;
                if (this.selectedUsers) {
                    angular.forEach(this.selectedUsers, (selectedUser: any) => {
                        if (selectedUser.uid == user.uid) {
                            found = true;
                        }
                    });
                }
                if (!found) {
                    matchedUsers.push(this.modelsUtils.user(user));
                }
            });
            angular.forEach(this.invites, (invite: any) => {
                if (
                    this.search == "" ||
                    (invite.campaigninviteemail &&
                        invite.campaigninviteemail.includes(this.search))
                ) {
                    let found = false;
                    if (this.selectedUsers) {
                        angular.forEach(this.selectedUsers, (selectedUser) => {
                            if (
                                (invite.campaigninviteemail &&
                                    selectedUser.campaigninviteemail ==
                                        invite.campaigninviteemail) ||
                                (invite.campaigninvitephonenumber &&
                                    invite.campaigninvitecountrycode &&
                                    invite.campaigninvitephonenumber ==
                                        selectedUser.campaigninvitephonenumber)
                            ) {
                                found = true;
                            }
                        });
                    }
                    angular.forEach(matchedUsers, (matchedUser: any) => {
                        if (
                            invite.campaigninviteid ==
                            matchedUser.campaigninviteid
                        ) {
                            found = true;
                        }
                    });
                    if (!found) {
                        matchedUsers.push(invite);
                    }
                }
            });
            return matchedUsers;
        }

        setSearchText(objProp: any): any {
            if (objProp && objProp != "") {
                return objProp;
            } else {
                return "";
            }
        }
    },
};

angular
    .module("user")
    .component(UserAutocompleteComponent.selector, UserAutocompleteComponent);
